import * as React from "react"
import { Link } from "gatsby"
import { MDXProvider } from "@mdx-js/react"

import {FullscreenContainer} from './JSBit/FullscreenContainer';
import ThemeToggle from "./ThemeToggle"

const shortcodes = { FullscreenContainer }


const Layout = ({ location, title, children }) => {
  const rootPath = `${__PATH_PREFIX__}/`
  const isRootPath = location.pathname === rootPath
  // Use a stable year that matches SSR — avoids React hydration mismatch #425
  const [year, setYear] = React.useState(2024)
  React.useEffect(() => {
    setYear(new Date().getFullYear())
  }, [])

  let header

  if (isRootPath) {
    header = (
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <h1 className="main-heading">
          <Link to="/">{title}</Link>
        </h1>
        <ThemeToggle />
      </div>
    )
  } else {
    header = (
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <Link className="header-link-home" to="/">
          {title}
        </Link>
        <ThemeToggle />
      </div>
    )
  }

  return (
    <MDXProvider components={shortcodes}>
      <div className="global-wrapper" data-is-root-path={isRootPath}>
        <header className="global-header">{header}</header>
        <main>{children}</main>
        <footer>
          © {year}, Built with
          {` `}
          <a href="https://www.gatsbyjs.com">Gatsby</a>
        </footer>
      </div>
    </MDXProvider>
  )
}

export default Layout
